module.exports = __webpack_public_path__ + "static/media/3-4-Tezky-kriz-nesl.8dfaef38.jpg";